import { getApiData, getApiTable, pickApiRowValue } from "./qmsApiUtils";
import { getVaultDocumentListId } from "./qmsVaultUtils";

export const DOCUMENT_CONTROL_TABLE = "DocumentControlDocuments";

export const DOCUMENT_CONTROL_FIELD_OPTIONS = [
  { key: "DocumentId", label: "Document ID" },
  { key: "DocumentTitle", label: "Title" },
  { key: "DocumentType", label: "Type" },
  { key: "DocumentCategory", label: "Category" },
  { key: "CreatedBy", label: "Owner" },
  { key: "VersionNumber", label: "Version" },
  { key: "DocumentStage", label: "Workflow stage" },
  { key: "ControlStatus", label: "Status" },
  { key: "PublishStatus", label: "Publish state" },
  { key: "PublishedDate", label: "Published" },
  { key: "SystemDateTime", label: "Updated" },
];

export const DEFAULT_DOCUMENT_CONTROL_COLUMNS = [
  "DocumentId",
  "DocumentTitle",
  "DocumentType",
  "DocumentCategory",
  "CreatedBy",
  "VersionNumber",
  "DocumentStage",
  "ControlStatus",
  "PublishedDate",
];

/** No right-pin — pinning mid/end columns caused values to paint under neighbors. */
export const DOCUMENT_CONTROL_PINNED_COLUMNS = [];

export const DOCUMENT_CONTROL_COLUMN_HEADER_CLASS = {
  DocumentTitle: "qms-document-control__col-title",
  CreatedBy: "qms-document-control__col-owner",
  VersionNumber: "qms-document-control__col-version",
  DocumentStage: "qms-document-control__col-stage",
  ControlStatus: "qms-document-control__col-status",
  DocumentType: "qms-document-control__col-lookup",
  DocumentCategory: "qms-document-control__col-lookup",
  PublishedDate: "qms-document-control__col-date",
  SystemDateTime: "qms-document-control__col-date",
};

export const QMS_DOCUMENT_CONTROL_PERMISSIONS = [
  "QMS_DOCUMENT_CONTROL",
  "QMS_TRACKER",
  "QMS_TRANSFER_OWNERSHIP",
  "QMS_ARCHIVE_DOCUMENTS",
  "QMS_UNARCHIVE_DOCUMENTS",
];

export function canAccessDocumentControl(screenAccess = {}) {
  return QMS_DOCUMENT_CONTROL_PERMISSIONS.some((key) => screenAccess[key]);
}

export function getDocumentControlList(response) {
  const named = getApiTable(response, DOCUMENT_CONTROL_TABLE);
  if (named.length) return named;

  const data = getApiData(response);
  if (!data || typeof data !== "object") return [];

  for (const key of Object.keys(data)) {
    const rows = data[key];
    if (!Array.isArray(rows) || !rows.length) continue;
    if (
      rows[0]?.ControlStatus != null ||
      rows[0]?.controlStatus != null ||
      rows[0]?.DocumentGroupIdRef != null
    ) {
      return rows;
    }
  }

  return [];
}

export function getDocumentControlFieldLabel(field) {
  return (
    DOCUMENT_CONTROL_FIELD_OPTIONS.find((option) => option.key === field)?.label ||
    field
  );
}

export function normalizeControlStatus(row) {
  return String(pickApiRowValue(row, "ControlStatus", "controlStatus") || "")
    .trim()
    .toLowerCase();
}

export function normalizePublishStatus(row) {
  return String(pickApiRowValue(row, "PublishStatus", "publishStatus") || "")
    .trim()
    .toLowerCase();
}

export function isDocumentControlArchived(row) {
  return normalizeControlStatus(row) === "archived";
}

export function canArchiveDocumentControlRow(row) {
  if (!row?.DocumentId) return false;
  if (isDocumentControlArchived(row)) return false;
  if (normalizePublishStatus(row) !== "published") return false;
  return Number(pickApiRowValue(row, "IsPublished", "isPublished")) === 1;
}

export function canTransferDocumentControlRow(row) {
  if (!row?.DocumentId) return false;
  return !isDocumentControlArchived(row);
}

export function getDocumentControlListId(row) {
  return getVaultDocumentListId(row);
}

export function getDocumentControlTitle(row) {
  const title = String(pickApiRowValue(row, "DocumentTitle", "documentTitle") || "").trim();
  const ext = String(pickApiRowValue(row, "DocumentExtension", "documentExtension") || "").trim();
  if (!title) return "—";
  if (ext && !title.toLowerCase().endsWith(`.${ext.toLowerCase()}`)) {
    return `${title}.${ext}`;
  }
  return title;
}
